import PropTypes from 'prop-types';
import { peacockBlue } from '@g4/boneyard/lib/theme/colors';
import allwaysIcon from "../images/icon-allways.png"
import styled from 'styled-components';
import Markdown from './Markdown';
import { Text } from './Boneyard';

const propTypes = {
    loyaltyFareDiscountText: PropTypes.object,
    discount: PropTypes.string
};

const AllwaysLogo = styled.img`
  width: 25px;
  height: 25px;
  margin-right: 10px;
  `;

const FlightBanner = styled.div`
display: flex;
align-items: center;
color: ${peacockBlue};
margin-bottom: 15px;
border: 1px solid #c7bdbd;
border-radius: 7px;
padding: 7px 10px;
font-weight: 500;
font-size: 1.1rem;
`

const FlightsPromoBanner = ({loyaltyFareDiscountText,discount}) => {
    let loyaltyFareDiscount = {
        loyalty_fare_discount: discount
    }
    return (
        <FlightBanner>
            <AllwaysLogo
                src={allwaysIcon}
            />
            <Text>
                <Markdown
                    source={loyaltyFareDiscountText}
                    data={loyaltyFareDiscount}
                />
            </Text>
        </FlightBanner>
    )
};

FlightsPromoBanner.propTypes = propTypes;

export default FlightsPromoBanner;
